module.exports = __webpack_public_path__ + "img/f2.382ce66f.jpg";